import { NgIf } from '@angular/common';
import { Component, input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'app-card-header',
  templateUrl: './card-header.component.html',
  imports: [IconComponent, NgIf, SpinnerComponent],
})
export class CardHeaderComponent {
  public title = input.required<string>();
  public subTitle = input<string | null>(null);
  public iconPath = input.required<string>();
  public progressAnimationDuration = input<number | undefined>();
  public showLoadingSpinner = input<boolean>(false);
}
